import { JobApplication } from '../models/job-application.model';

const normalizedName = (value: unknown): string =>
  typeof value === 'string' ? value.trim() : '';

export const recruiterName = (
  application: JobApplication,
  ownerScopedRecruiter?: string
): string =>
  normalizedName(application.recruiter) ||
  normalizedName(application.ownerFullname) ||
  normalizedName(application.job?.owner?.fullname) ||
  normalizedName(ownerScopedRecruiter) ||
  'Not assigned';
